var app = angular.module('leonardo');

var TaskListPaginated = function (
  $scope,
  $state,
  $q,
  $filter,
  $attrs,
  FilterService,
  TaskService,
  RecurrenceService,
  $timeout,
  ngDialog,
  PropertyService,
  TemplateService,
  $controller,
  $rootScope,
  blockUI
) {
  $scope.taskMode = $state.current.taskMode ? $state.current.taskMode : 'property';
  $scope.filterService = FilterService;

  $scope.daily_period = 0;
  $scope.weekly_period = 0;
  $scope.monthly_period = 0;

  $scope.currentDate = [];

  $scope.today = moment().format('YYYY-MM-DD');
  if ($attrs.past) {
    $scope.today = RecurrenceService.prev($attrs.mode, $scope.today);
  }

  $scope.taskGroups = [];
  $scope.tasks_no_unit = [];

  $scope.unitExpanded = null;

  $scope.reset_page = false;
  $scope.update = false;

  // Get separate blockUI instances for each section
  var pendingBlock = blockUI.instances.get('pending-section');
  var cannotDoBlock = blockUI.instances.get('cannot-do-section');
  var reviewPendingBlock = blockUI.instances.get('review-pending-section');
  var reviewRevisionBlock = blockUI.instances.get('review-revision-section');
  var reviewRejectedBlock = blockUI.instances.get('review-rejected-section');
  var completedBlock = blockUI.instances.get('completed-section');
  var monthlyBlock = blockUI.instances.get('monthly-section');
  var weeklyBlock = blockUI.instances.get('weekly-section');
  var dailyBlock = blockUI.instances.get('daily-section');
  var workflowBlock = blockUI.instances.get('workflow-section');
  var workspaceBlock = blockUI.instances.get('workspace-section');
  var documentBlock = blockUI.instances.get('document-section');

  // Helper to get the block instance
  function getBlockInstance(mode) {
    switch (mode) {
      case 'completed':
        return completedBlock;
      case 'cannot-do':
        return cannotDoBlock;
      case 'review-pending':
        return reviewPendingBlock;
      case 'review-revision':
        return reviewRevisionBlock;
      case 'review-rejected':
        return reviewRejectedBlock;
      case 'by_unit':
        return pendingBlock;
      case 'monthly':
        return monthlyBlock;
      case 'weekly':
        return weeklyBlock;
      case 'daily':
        return dailyBlock;
      case 'workflow':
        return workflowBlock;
      case 'workspace':
        return workspaceBlock;
      case 'document':
        return documentBlock;
      default:
        return null;
    }
  }

  // Reset block counts on initialization
  [pendingBlock, cannotDoBlock, reviewPendingBlock, reviewRevisionBlock, reviewRejectedBlock, completedBlock, monthlyBlock, weeklyBlock, dailyBlock, workflowBlock, workspaceBlock, documentBlock].forEach(block => {
    if (block) {
      block.state().blockCount = 0;
    }
  });

  $scope.showDialogWorkflow = function () {
    ngDialog.open({
      template: 'views/templates/dialog/workflow/list.html',
      controller: 'WorkFlowListDialog',
      data: {
        property: FilterService.getFilter('property')
      }
    });
  };

  $scope.unitIsExpanded = function (unit) {
    return $scope.unitExpanded === unit;
  };

  $scope.toggleUnit = function (unit) {
    $scope.unitExpanded = $scope.unitExpanded === unit ? null : unit;
  };

  $scope.getApostrophe = function () {
    var name = FilterService.getPropertyName();
    if (isNull(name) || name[name.length - 1] === 's' || name[name.length - 1] === 'S') {
      return "'";
    } else {
      return "'s";
    }
  };

  $scope.getPeriodType = function (mode, date) {
    var currentDate = RecurrenceService.getValue(mode, moment().format('YYYY-MM-DD'));
    var dueDate = RecurrenceService.prev(mode, currentDate);
    var prev = null;
    switch (mode) {
      case 'daily':
        prev = moment(currentDate).subtract(30, 'days').format('YYYY-MM-DD');
        $scope.period_prev_date = prev;
        break;
      case 'weekly':
        prev = moment(currentDate).subtract(4, 'weeks').format('YYYY-MM-DD');
        var d = moment(prev);
        switch (RecurrenceService.getWeek(prev)) {
          case 'first':
            $scope.period_prev_date = d.date(1).format('YYYY-MM-DD');
            break;
          case 'second':
            $scope.period_prev_date = d.date(8).format('YYYY-MM-DD');
            break;
          case 'third':
            $scope.period_prev_date = d.date(15).format('YYYY-MM-DD');
            break;
          case 'last':
            $scope.period_prev_date = d.date(22).format('YYYY-MM-DD');
            break;
        }
        break;
      default:
        prev = dueDate;
        $scope.period_prev_date = moment(prev).date(1).format('YYYY-MM-DD');
        break;
    }
    if (date > dueDate) {
      return 0;
    } else if (date >= prev) {
      return 1;
    } else {
      return 2;
    }
  };

  $scope.getDatesPeriod = function (mode, date) {
    switch (mode) {
      case 'daily':
        $scope.daily_period = $scope.getPeriodType(mode, date);
        break;
      case 'weekly':
        $scope.weekly_period = $scope.getPeriodType(mode, date);
        break;
      case 'monthly':
        $scope.monthly_period = $scope.getPeriodType(mode, date);
        break;
      default:
        break;
    }
  };

  $scope.getClasses = function (task) {
    var classes = [];
    if (task && !isNull(task.priority)) {
      switch (task.priority.toString()) {
        case TemplateService.PRIORITY_CRITICAL:
          classes.push('priority-critical');
          break;
        case TemplateService.PRIORITY_NORMAL:
          classes.push('priority-normal');
          break;
        case TemplateService.PRIORITY_MINOR:
          classes.push('priority-minor');
          break;
      }
    }
    return classes;
  };

  $scope.getColor = function (task) {
    var color = 'primaryColor';
    if (task && !isNull(task.priority)) {
      switch (task.priority.toString()) {
        case TemplateService.PRIORITY_CRITICAL:
          color = 'errorColor';
          break;
        case TemplateService.PRIORITY_NORMAL:
          color = 'warningColor';
          break;
        case TemplateService.PRIORITY_MINOR:
          color = 'tertiaryColor';
          break;
      }
    }
    return color;
  };

  $scope.next = function () {
    if (!RecurrenceService.hasNext($attrs.mode, $scope.dueDate)) {
      return;
    }
    $scope.dueDate = RecurrenceService.next($attrs.mode, $scope.dueDate);
    $scope.dueDateCalendar = angular.copy($scope.dueDate);
    $scope.getDatesPeriod($attrs.mode, $scope.dueDate);
    $rootScope.$broadcast('task-status-date:updated', $attrs.mode, $scope.dueDate);
    $scope.loadPage(1);
  };

  $scope.prev = function () {
    $scope.dueDate = RecurrenceService.prev($attrs.mode, $scope.dueDate);
    $scope.dueDateCalendar = angular.copy($scope.dueDate);
    $scope.getDatesPeriod($attrs.mode, $scope.dueDate);
    $rootScope.$broadcast('task-status-date:updated', $attrs.mode, $scope.dueDate);
    $scope.loadPage(1);
  };

  $scope.changeDate = function (date) {
    if (!date) {
      return;
    }
    var d = moment(date);
    if (d.format('YYYY-MM-DD') === $scope.dueDate) {
      return;
    }
    $scope.dueDate = RecurrenceService.getValue($attrs.mode, date);
    $scope.dueDateCalendar = angular.copy($scope.dueDate);
    $scope.getDatesPeriod($attrs.mode, $scope.dueDate);
    if ($scope.init) {
      $scope.getDatesPeriod($attrs.mode, $scope.dueDate);
      $rootScope.$broadcast('task-status-date:updated', $attrs.mode, $scope.dueDate);
      $scope.loadPage(1);
    }
  };

  $scope.hasNext = function () {
    if ($scope.initialDueDate === $scope.dueDate) {
      return false;
    }
    return RecurrenceService.hasNext($attrs.mode, $scope.dueDate);
  };

  $scope.initParams = function () {
    $scope.tasks = [];
    $scope.dueTasks = [];
    $scope.dueDate = moment().format('YYYY-MM-DD');
    $scope.dueTasksVisible = false;
    $scope.dueTasksEnabled = $attrs.dueTasksEnabled ? true : false;

    if ($attrs.past && !_.contains(['snoozed'], $attrs.mode)) {
      $scope.dueDate = RecurrenceService.prev($attrs.mode, $scope.dueDate);
    } else {
      $scope.dueDate = RecurrenceService.getValue($attrs.mode, $scope.dueDate);
    }

    $scope.initialDueDate = angular.copy($scope.dueDate);
    $scope.dueDateCalendar = angular.copy($scope.dueDate);
  };

  $scope.getParams = function (dueDate, reset_page, typeTask) {
    var params = {
      summary: true
    };
    var recurrenceArray = [TemplateService.RECURRENCE_DAILY, TemplateService.RECURRENCE_FIXED_DATE, TemplateService.RECURRENCE_WEEKLY];
    if ($attrs.incomplete) {
      params['prior_period'] = 1;
    }
    var today = moment($scope.today);
    var dateDueDate = moment(dueDate);
    switch ($attrs.mode) {
      case 'daily':
        params['type_task'] = TaskService.TYPE_TASK_DEFAULT;
        params['status'] = TaskService.STATUS_PENDING;
        params['recurrence_type'] = recurrenceArray.join(',');
        if (typeTask === 'daily_no_period') {
          params['never_fall_off_before'] = dueDate;
        } else {
          if ($scope.daily_period === 2) {
            params['due_date'] = dueDate;
          } else if ($scope.daily_period === 1) {
            params['due_date'] = dueDate;
            params['period'] = $scope.daily_period;
          } else {
            params['due_date__gte'] = dueDate;
            params['period'] = $scope.daily_period;
          }
        }
        break;
      case 'weekly':
        params['type_task'] = TaskService.TYPE_TASK_DEFAULT;
        params['status'] = TaskService.STATUS_PENDING;
        params['recurrence_type'] = TemplateService.RECURRENCE_MONTHLY;
        switch (RecurrenceService.getWeek(dueDate)) {
          case 'first':
            params['due_date__gte'] = moment(dateDueDate).date(1).format('YYYY-MM-DD');
            break;
          case 'second':
            params['due_date__gte'] = moment(dateDueDate).date(8).format('YYYY-MM-DD');
            break;
          case 'third':
            params['due_date__gte'] = moment(dateDueDate).date(15).format('YYYY-MM-DD');
            break;
          case 'last':
            params['due_date__gte'] = moment(dateDueDate).date(22).format('YYYY-MM-DD');
            break;
        }
        if ($scope.weekly_period === 2) {
          params['due_date__lte'] = dueDate;
        } else if ($scope.weekly_period === 1) {
          params['due_date__lte'] = dueDate;
          params['period'] = $scope.weekly_period;
        } else {
          params['period'] = $scope.weekly_period;
        }
        break;
      case 'monthly':
        params['type_task'] = TaskService.TYPE_TASK_DEFAULT;
        params['status'] = TaskService.STATUS_PENDING;
        params['recurrence_type'] = TemplateService.RECURRENCE_YEARLY;
        if ($scope.monthly_period === 2) {
          params['due_date__gte'] = moment(dateDueDate).date(1).format('YYYY-MM-DD');
          params['due_date__lte'] = dueDate;
        } else {
          params['due_date__gte'] = moment(dateDueDate).date(1).format('YYYY-MM-DD');
          params['period'] = $scope.monthly_period;
        }
        break;
      case 'document':
        params['type_task'] = TaskService.TYPE_TASK_DOCUMENT;
        params['status'] = TaskService.STATUS_PENDING;
        if ($attrs.past) {
          params['due_date__gte'] = moment(today).subtract(1, 'years').format('YYYY-MM-DD');
          params['due_date__lte'] = moment(today).subtract(1, 'months').format('YYYY-MM-DD');
        } else {
          params['due_date__gte'] = moment(today).subtract(1, 'months').format('YYYY-MM-DD');
        }
        break;
      case 'workflow':
        params['status'] = TaskService.STATUS_PENDING;
        params['type_task'] = TaskService.TYPE_TASK_WORKFLOW;
        params['wf_by_unit'] = false;
        params['by_unit'] = false;
        break;
      case 'completed':
        params['status'] = TaskService.STATUS_SOLVED;
        if ($scope.taskMode !== 'by_unit') {
          params['limit'] = 20;
          $scope.tableFilterSize = 20;
        }
        if (typeTask === 'daily') {
          params['recurrence_type'] = recurrenceArray.join(',');
          params['type_task'] = TaskService.TYPE_TASK_DEFAULT;
          if ($scope.daily_period === 2) {
            params['due_date'] = dueDate;
          } else if ($scope.daily_period === 1) {
            params['due_date'] = dueDate;
            params['period'] = $scope.daily_period;
          } else {
            params['period'] = $scope.daily_period;
          }
        } else if (typeTask === 'weekly') {
          params['recurrence_type'] = TemplateService.RECURRENCE_MONTHLY;
          params['type_task'] = TaskService.TYPE_TASK_DEFAULT;
          if ($scope.weekly_period === 2) {
            params['due_date__gte'] = moment(dateDueDate).subtract(6, 'days').format('YYYY-MM-DD');
            params['due_date__lte'] = dueDate;
          } else if ($scope.weekly_period === 1) {
            params['due_date__gte'] = moment(dateDueDate).subtract(6, 'days').format('YYYY-MM-DD');
            params['due_date__lte'] = dueDate;
            params['period'] = $scope.weekly_period;
          } else {
            params['period'] = $scope.weekly_period;
          }
        } else if (typeTask === 'monthly') {
          params['recurrence_type'] = TemplateService.RECURRENCE_YEARLY;
          params['type_task'] = TaskService.TYPE_TASK_DEFAULT;
          if ($scope.monthly_period === 2) {
            params['due_date__gte'] = moment(dateDueDate).date(1).format('YYYY-MM-DD');
            params['due_date__lte'] = dueDate;
          } else {
            params['period'] = $scope.monthly_period;
          }
        } else if (typeTask === 'document') {
          params['type_task'] = TaskService.TYPE_TASK_DOCUMENT;
          params['due_date'] = dueDate;
        } else if (typeTask === 'workflow') {
          params['type_task'] = TaskService.TYPE_TASK_WORKFLOW;
          params['wf_by_unit'] = false;
        }
        break;
      case 'cannot-do':
        params['status'] = TaskService.STATUS_CANNOT_DO;
        if ($scope.taskMode !== 'by_unit') {
          params['limit'] = 20;
          $scope.tableFilterSize = 20;
        }
        if (typeTask === 'daily') {
          params['recurrence_type'] = recurrenceArray.join(',');
          params['type_task'] = TaskService.TYPE_TASK_DEFAULT;
          if ($scope.daily_period === 2) {
            params['due_date'] = dueDate;
          } else if ($scope.daily_period === 1) {
            params['due_date'] = dueDate;
            params['period'] = $scope.daily_period;
          } else {
            params['period'] = $scope.daily_period;
          }
        } else if (typeTask === 'weekly') {
          params['recurrence_type'] = TemplateService.RECURRENCE_MONTHLY;
          params['type_task'] = TaskService.TYPE_TASK_DEFAULT;
          if ($scope.weekly_period === 2) {
            params['due_date__gte'] = moment(dateDueDate).subtract(6, 'days').format('YYYY-MM-DD');
            params['due_date__lte'] = dueDate;
          } else if ($scope.weekly_period === 1) {
            params['due_date__gte'] = moment(dateDueDate).subtract(6, 'days').format('YYYY-MM-DD');
            params['due_date__lte'] = dueDate;
            params['period'] = $scope.weekly_period;
          } else {
            params['period'] = $scope.weekly_period;
          }
        } else if (typeTask === 'monthly') {
          params['recurrence_type'] = TemplateService.RECURRENCE_YEARLY;
          params['type_task'] = TaskService.TYPE_TASK_DEFAULT;
          if ($scope.monthly_period === 2) {
            params['due_date__gte'] = moment(dateDueDate).date(1).format('YYYY-MM-DD');
            params['due_date__lte'] = dueDate;
          } else {
            params['period'] = $scope.monthly_period;
          }
        } else if (typeTask === 'document') {
          params['type_task'] = TaskService.TYPE_TASK_DOCUMENT;
          if ($attrs.past) {
            params['due_date__gte'] = moment(dateDueDate).subtract(1, 'years').format('YYYY-MM-DD');
            params['due_date__lte'] = moment(dateDueDate).subtract(1, 'months').format('YYYY-MM-DD');
          } else {
            params['due_date'] = dueDate;
          }
        } else if (typeTask === 'workflow') {
          params['type_task'] = TaskService.TYPE_TASK_WORKFLOW;
          params['wf_by_unit'] = false;
          if ($attrs.past) {
            params['due_date__gte'] = moment(dateDueDate).subtract(1, 'years').format('YYYY-MM-DD');
            params['due_date__lte'] = moment(dateDueDate).subtract(1, 'months').format('YYYY-MM-DD');
          } else {
            params['due_date__gte'] = moment(dateDueDate).subtract(30, 'days').format('YYYY-MM-DD');
          }
        }
        break;
      case 'snoozed':
        params['status'] = TaskService.STATUS_PENDING;
        params['type_task'] = TaskService.TYPE_TASK_DEFAULT;
        params['snoozed'] = true;
        params['due_date__gt'] = dueDate;
        break;
      case 'review-pending':
        params['status'] = TaskService.STATUS_APPROVAL_IN_PROGRESS;
        if ($scope.taskMode !== 'by_unit') {
          params['limit'] = 20;
          $scope.tableFilterSize = 20;
        }
        break;
      case 'review-revision':
        params['status'] = TaskService.STATUS_APPROVAL_RETURN_SUBMITTER;
        if ($scope.taskMode !== 'by_unit') {
          params['limit'] = 20;
          $scope.tableFilterSize = 20;
        }
        break;
      case 'review-rejected':
        params['status'] = TaskService.STATUS_APPROVAL_REJECTED;
        if ($scope.taskMode !== 'by_unit') {
          params['limit'] = 20;
          $scope.tableFilterSize = 20;
        }
        break;
      default:
        params['status'] = TaskService.STATUS_PENDING;
        break;
    }

    switch (typeTask) {
      case 'daily':
        params['recurrence_type'] = recurrenceArray.join(',');
        params['type_task'] = TaskService.TYPE_TASK_DEFAULT;
        if ($scope.daily_period === 2) {
          params['due_date'] = dueDate;
        } else if ($scope.daily_period === 1) {
          params['due_date'] = dueDate;
          params['period'] = $scope.daily_period;
        } else {
          params['period'] = $scope.daily_period;
        }
        break;
      case 'weekly':
        params['recurrence_type'] = TemplateService.RECURRENCE_MONTHLY;
        params['type_task'] = TaskService.TYPE_TASK_DEFAULT;
        if ($scope.weekly_period === 2) {
          params['due_date__gte'] = moment(dateDueDate).subtract(6, 'days').format('YYYY-MM-DD');
          params['due_date__lte'] = dueDate;
        } else if ($scope.weekly_period === 1) {
          params['due_date__gte'] = moment(dateDueDate).subtract(6, 'days').format('YYYY-MM-DD');
          params['due_date__lte'] = dueDate;
          params['period'] = $scope.weekly_period;
        } else {
          params['period'] = $scope.weekly_period;
        }
        break;
      case 'monthly':
        params['recurrence_type'] = TemplateService.RECURRENCE_YEARLY;
        params['type_task'] = TaskService.TYPE_TASK_DEFAULT;
        if ($scope.monthly_period === 2) {
          params['due_date__gte'] = moment(dateDueDate).date(1).format('YYYY-MM-DD');
          params['due_date__lte'] = dueDate;
        } else {
          params['period'] = $scope.monthly_period;
        }
        break;
      case 'document':
        params['type_task'] = TaskService.TYPE_TASK_DOCUMENT;
        if ($attrs.past) {
          params['due_date__gte'] = moment(dateDueDate).subtract(1, 'years').format('YYYY-MM-DD');
          params['due_date__lte'] = moment(dateDueDate).subtract(1, 'months').format('YYYY-MM-DD');
        } else {
          params['due_date'] = dueDate;
        }
        break;
      case 'workflow':
        params['type_task'] = TaskService.TYPE_TASK_WORKFLOW;
        params['by_unit'] = false;
        var date_param = 'due_date';
        if ($attrs.mode === 'completed') {
          date_param = 'completed_date';
        }
        if ($attrs.past) {
          params[date_param + '__gte'] = moment(dateDueDate).subtract(1, 'years').format('YYYY-MM-DD');
          params[date_param + '__lte'] = moment(dateDueDate).subtract(1, 'months').format('YYYY-MM-DD');
        } else {
          if(!['review-pending', 'review-revision', 'review-rejected'].includes($attrs.mode)){
            params[date_param + '__gte'] = moment(dateDueDate).subtract(180, 'days').format('YYYY-MM-DD');
          }
        }
        break;
    }

    switch ($scope.taskMode) {
      case 'property':
        if (FilterService.hasFilter('property')) {
          params['property'] = FilterService.getFilter('property');
        } else if (FilterService.hasFilter('portfolio')) {
          params['portfolio'] = FilterService.getFilter('portfolio');
        } else if (FilterService.hasFilter('group')) {
          params['group'] = FilterService.getFilter('group');
        } else if (FilterService.hasFilter('account')) {
          params['account'] = FilterService.getFilter('account');
        }
        break;
      case 'by_unit':
        if (FilterService.hasFilter('property')) {
          params['property'] = FilterService.getFilter('property');
        } else if (FilterService.hasFilter('portfolio')) {
          params['portfolio'] = FilterService.getFilter('portfolio');
        } else if (FilterService.hasFilter('group')) {
          params['group'] = FilterService.getFilter('group');
        } else if (FilterService.hasFilter('account')) {
          params['account'] = FilterService.getFilter('account');
        }
        if (FilterService.hasFilter('unit_number_search')) {
          params['unit_number_search'] = FilterService.getFilter('unit_number_search');
        }
        if (FilterService.hasFilter('unit_building_search')) {
          params['unit_building_search'] = FilterService.getFilter('unit_building_search');
        }
        if (FilterService.hasFilter('name')) {
          params['name'] = FilterService.getFilter('name');
        }
        params['type_task'] = TaskService.TYPE_TASK_WORKFLOW;
        params['wf_by_unit'] = true;
        params['by_unit'] = true;
        break;
      case 'owner':
        params['personal'] = 1;
        break;
    }

    if (FilterService.hasFilter('category')) {
      params['category'] = FilterService.getFilter('category');
    }

    if (FilterService.hasFilter('priority')) {
      params['priority'] = FilterService.getFilter('priority');
    }

    if (FilterService.hasFilter('managed_by')) {
      params['managed_by'] = FilterService.getFilter('managed_by');
    }
    if (FilterService.hasFilter('role')) {
      params['roles'] = FilterService.getFilter('role');
    }
    if (FilterService.hasFilter('account_users_assigned')) {
      params['account_users_assigned'] = FilterService.getFilter('account_users_assigned');
    }
    if (reset_page) {
      FilterService.setFilter('page', 1);
    }

    return params;
  };

  $scope.updateTasks = function (mode, dueDate) {
    $scope.tasks = [];
    let defer = $q.defer();
    let date_mode = RecurrenceService.getValue(mode, dueDate);
    switch (mode) {
      case 'daily':
        $scope.dueDate = date_mode;
        break;
      case 'weekly':
        $scope.dueDate_weekly = date_mode;
        break;
      case 'monthly':
        $scope.dueDate_monthly = date_mode;
        break;
    }
    let block = 'block';
    switch ($attrs.mode) {
      case 'completed':
        block = 'block-completed';
        break;
      case 'cannot-do':
        block = 'block-cannot-do';
        break;
      case 'review-pending':
        block = 'block-approval-in-progress';
        break;
      case 'review-revision':
        block = 'block-returned-to-submitter';
        break;
      case 'review-rejected':
        block = 'block-approval-rejected';
        break;
    }
    TaskService.getTasklist(block, $scope.getParams(date_mode, false, mode)).then(
      function (data) {
        $scope.datas[mode] = data;
        defer.resolve(data.results ? data.results : data);
      },
      function (error) {
        if (error.data && angular.isString(error.data.detail) && error.data.detail.startsWith('Invalid page')) {
          $scope.datas[mode] = {};
          defer.resolve([]);
        }
        defer.reject();
      }
      );
    $q.when(defer.promise).then(function (data) {
      if (data) {
        if (mode === 'daily') {
          $scope.tasks_daily = data;
        }
        if (mode === 'weekly') {
          $scope.tasks_weekly = data;
        }
        if (mode === 'monthly') {
          $scope.tasks_monthly = data;
        }
        if (mode === 'document') {
          $scope.tasks_documents = data;
        }
        if (mode === 'workflow') {
          $scope.tasks_workflows = data;
        }
      }
      if ($scope.tasks_daily) {
        $scope.tasks = $scope.tasks.concat($scope.tasks_daily);
      }
      if ($scope.tasks_weekly) {
        $scope.tasks = $scope.tasks.concat($scope.tasks_weekly);
      }
      if ($scope.tasks_monthly) {
        $scope.tasks = $scope.tasks.concat($scope.tasks_monthly);
      }
      if ($scope.tasks_documents) {
        $scope.tasks = $scope.tasks.concat($scope.tasks_documents);
      }
      if ($scope.tasks_workflows) {
        $scope.tasks = $scope.tasks.concat($scope.tasks_workflows);
      }
      let dataResult = $scope.updateData();
      $scope.collection['total'] = dataResult.meta ? dataResult.meta.count : dataResult.count;
    });
  };

  $scope.getBlockTasks = function (block, options, params, ordering, comparator) {
    $scope.showLoader = true;
    let defer = $q.defer();
    let paramsTasks = params || $scope.getParams($scope.dueDate, $scope.reset_page);
    let optionsTasks = angular.copy(options);
    let orderTasks = ordering || '';
    let strictOrder = !isNull(comparator) ? comparator : false;
    angular.forEach(paramsTasks, function (value, key) {
      optionsTasks[key] = value;
    });
    TaskService.getTasklist(block, optionsTasks).then(
      function (data) {
        let results = data.results ? data.results : data;
        if (results.length > 0) {
          $scope.$parent.$parent.loading = false;
        }
        results = $filter('orderBy')(results, [orderTasks], strictOrder);
        defer.resolve({ data: data, results: results });
        $scope.showLoader = false;
      },
      function (error) {
        defer.reject(error);
        // Set the error message to display in the view
        $scope.errorMessage = error.data?.detail;
        $scope.showLoader = false;
      }
    );
    return defer.promise;
  };

  $scope.getGroupBlockTasks = function (block, sub_blocks, options) {
    let defer = $q.defer();
    let tasks = {};
    let promises = [];
    angular.forEach(sub_blocks, function (sub_block) {
      tasks[sub_block] = [];
      promises.push(
        $scope.getBlockTasks(block, options, $scope.getParams($scope.dueDate, $scope.reset_page, sub_block)).then(
          function (data) {
            tasks[sub_block] = data.results;
            $scope.datas[sub_block] = data.data;
          },
          function (error) {
            if (error.data && angular.isString(error.data.detail) && error.data.detail.startsWith('Invalid page')) {
              tasks[sub_block] = [];
              $scope.datas[sub_block] = {};
            }
          }
        )
      );
    });

    $q.all(promises).then(function () {
      let results = [];
      angular.forEach(sub_blocks, function (sub_block) {
        results = results.concat(tasks[sub_block]);
      });
      defer.resolve({ data: $scope.updateData(), tasks: tasks, results: results });
    });
    return defer.promise;
  };

  $scope.stopAllBlocks = function() {
    [pendingBlock, cannotDoBlock, reviewPendingBlock, reviewRevisionBlock, reviewRejectedBlock, completedBlock, monthlyBlock, weeklyBlock, dailyBlock, workflowBlock, workspaceBlock, documentBlock].forEach(block => {
      if (block) {
        block.stop();
      }
    });
  };

  $scope.getEntitiesPromise = function (options) {
    var defer = $q.defer();
  
    if (FilterService.properties.length === 0) {
      defer.resolve([]);
      return defer.promise;
    }
  
    const blockInstance = getBlockInstance($attrs.mode);  // Get the blockUI instance for the current section (mode)
    if (blockInstance) {
      blockInstance.start('Loading tasks...');  // Start the blockUI for this section
    }
  
    var promises = [];
    var params = {};
    $scope.rangeDates = RecurrenceService.getDateRanges($attrs.mode, $scope.dueDate);
    $scope.tasks = [];
    $scope.dueTasks = [];
    $scope.datas = {};
    switch ($attrs.mode) {
      case 'workflow':
          $scope.getBlockTasks('block-workflow', options).then(
            function (data) {
              $scope.tasks = data.results;
              defer.resolve(data.data);
              if (blockInstance) blockInstance.stop();  // Stop the correct blockUI instance
            },
            function (error) {
              defer.reject(error);
              if (blockInstance) blockInstance.stop();  // Stop the correct blockUI instance
            }
        );
        break;
      case 'document':
          $scope.getBlockTasks('block-documents', options).then(
            function (data) {
              $scope.tasks = data.results;
              defer.resolve(data.data);
              if(blockInstance) blockInstance.stop();
            },
            function (error) {
              defer.reject(error);
              if(blockInstance) blockInstance.stop();
            }
        );
        break;
      case 'completed':
        if ($scope.taskMode === 'by_unit') {
            $scope.getBlockTasks('block-completed', options, null, ['workflow_instance.unit.building', 'workflow_instance.unit.number'], false).then(
              function (data) {
                updateResultTask(data, defer, blockInstance);
              },
              function (error) {
                defer.reject(error);
                if (blockInstance) blockInstance.stop();  // Stop the correct blockUI instance
              }
          );
        } else {
          $scope.tasks_daily = [];
          $scope.tasks_weekly = [];
          $scope.tasks_monthly = [];
          $scope.tasks_documents = [];
          $scope.tasks_workflows = [];
          if (!$scope.update) {
            if ($attrs.past) {
              $scope.dueDate_weekly = RecurrenceService.prev('weekly', $scope.dueDate);
              $scope.dueDate_monthly = RecurrenceService.prev('monthly', $scope.dueDate);
            } else {
              $scope.dueDate_weekly = RecurrenceService.getValue('weekly', $scope.dueDate);
              $scope.dueDate_monthly = RecurrenceService.getValue('monthly', $scope.dueDate);
            }
          }
          $scope.getGroupBlockTasks('block-completed', ['daily', 'weekly', 'monthly', 'document', 'workflow'], options).then(function (data) {
            updatetaskdocumentdetail(data, defer, blockInstance);
          });
        }
        break;
      case 'cannot-do':
        if ($scope.taskMode === 'by_unit') {
          $scope.getBlockTasks('block-cannot-do', options, null, ['workflow_instance.unit.building', 'workflow_instance.unit.number'], false).then(
              function (data) {
              updateResultTask(data, defer, blockInstance);
              },
              function (error) {
                defer.reject(error);
                if (blockInstance) blockInstance.stop();  // Stop the correct blockUI instance
              }
          );
        } else {
          $scope.tasks_daily = [];
          $scope.tasks_weekly = [];
          $scope.tasks_monthly = [];
          $scope.tasks_documents = [];
          $scope.tasks_workflows = [];
          if (!$scope.update) {
            if ($attrs.past) {
              $scope.dueDate_weekly = RecurrenceService.prev('weekly', $scope.dueDate);
              $scope.dueDate_monthly = RecurrenceService.prev('monthly', $scope.dueDate);
            } else {
              $scope.dueDate_weekly = RecurrenceService.getValue('weekly', $scope.dueDate);
              $scope.dueDate_monthly = RecurrenceService.getValue('monthly', $scope.dueDate);
            }
          }
          $scope.getGroupBlockTasks('block-cannot-do', ['daily', 'weekly', 'monthly', 'document', 'workflow'], options).then(function (data) {
            updatetaskdocumentdetail(data, defer, blockInstance);
          });
        }
        break;
      case 'snoozed':
        $scope.getBlockTasks('block-snoozed', options).then(
          function (data) {
            $scope.tasks = data.results;
            defer.resolve(data.data);
          },
          function (error) {
            defer.reject(error);
          }
        );
        break;
      case 'review-pending':
        if ($scope.taskMode === 'by_unit') {
          $scope
            .getBlockTasks('block-approval-in-progress', options, null, ['workflow_instance.unit.building', 'workflow_instance.unit.number'], false)
            .then(
            function (data) {
              updateResultTask(data, defer, blockInstance);
            },
            function (error) {
              defer.reject(error);
              if (blockInstance) blockInstance.stop();  // Stop the correct blockUI instance
            }
            );
        } else {
          $scope.tasks_daily = [];
          $scope.tasks_weekly = [];
          $scope.tasks_monthly = [];
          $scope.tasks_workflows = [];
          if (!$scope.update) {
            if ($attrs.past) {
              $scope.dueDate_weekly = RecurrenceService.prev('weekly', $scope.dueDate);
              $scope.dueDate_monthly = RecurrenceService.prev('monthly', $scope.dueDate);
            } else {
              $scope.dueDate_weekly = RecurrenceService.getValue('weekly', $scope.dueDate);
              $scope.dueDate_monthly = RecurrenceService.getValue('monthly', $scope.dueDate);
            }
          }
          $scope.getGroupBlockTasks('block-approval-in-progress', ['daily', 'weekly', 'monthly', 'workflow'], options).then(function (data) {
            updateTaskwithoutdocumentdetail(data, defer, blockInstance);
          });
        }
        break;
      case 'review-revision':
        if ($scope.taskMode === 'by_unit') {
          $scope
            .getBlockTasks('block-returned-to-submitter', options, null, ['workflow_instance.unit.building', 'workflow_instance.unit.number'], false)
            .then(
              function (data) {
                updateResultTask(data, defer, blockInstance);
              },
              function (error) {
                defer.reject(error);
                if (blockInstance) blockInstance.stop();  // Stop the correct blockUI instance
              }
            );
        } else {
          $scope.tasks_daily = [];
          $scope.tasks_weekly = [];
          $scope.tasks_monthly = [];
          $scope.tasks_workflows = [];
          if (!$scope.update) {
            if ($attrs.past) {
              $scope.dueDate_weekly = RecurrenceService.prev('weekly', $scope.dueDate);
              $scope.dueDate_monthly = RecurrenceService.prev('monthly', $scope.dueDate);
            } else {
              $scope.dueDate_weekly = RecurrenceService.getValue('weekly', $scope.dueDate);
              $scope.dueDate_monthly = RecurrenceService.getValue('monthly', $scope.dueDate);
            }
          }
          $scope.getGroupBlockTasks('block-returned-to-submitter', ['daily', 'weekly', 'monthly', 'workflow'], options).then(function (data) {
            updateTaskwithoutdocumentdetail(data, defer, blockInstance);
          });
        }
        break;
      case 'review-rejected':
        if ($scope.taskMode === 'by_unit') {
          $scope
            .getBlockTasks('block-approval-rejected', options, null, ['workflow_instance.unit.building', 'workflow_instance.unit.number'], false)
            .then(
            function (data) {
              updateResultTask(data, defer, blockInstance);
            },
            function (error) {
              defer.reject(error);
              if (blockInstance) blockInstance.stop();  // Stop the correct blockUI instance
            }
            );
        } else {
          $scope.tasks_daily = [];
          $scope.tasks_weekly = [];
          $scope.tasks_monthly = [];
          $scope.tasks_workflows = [];
          if (!$scope.update) {
            if ($attrs.past) {
              $scope.dueDate_weekly = RecurrenceService.prev('weekly', $scope.dueDate);
              $scope.dueDate_monthly = RecurrenceService.prev('monthly', $scope.dueDate);
            } else {
              $scope.dueDate_weekly = RecurrenceService.getValue('weekly', $scope.dueDate);
              $scope.dueDate_monthly = RecurrenceService.getValue('monthly', $scope.dueDate);
            }
          }
          $scope.getGroupBlockTasks('block-approval-rejected', ['daily', 'weekly', 'monthly', 'workflow'], options).then(function (data) {
            updateTaskwithoutdocumentdetail(data, defer, blockInstance);
          });
        }
        break;
      case 'workspace':
        params = $scope.getParams($scope.dueDate, $scope.reset_page);
        angular.forEach(params, function (value, key) {
          options[key] = value;
        });
        TaskService.workspace(options).then(
          function (data) {
            $scope.tasks_left = [];
            $scope.tasks_right = [];
            var results = data.results ? data.results : data;
            angular.forEach(results, function (value, key) {
              if (key < 5) {
                $scope.tasks_left.push(value);
              } else {
                $scope.tasks_right.push(value);
              }
            });
            if (results.length > 0) {
              $scope.$parent.$parent.loading = false;
            }
            defer.resolve(data);
            if(blockInstance) blockInstance.stop();
          },
          function (error) {
            defer.reject(error);
            if(blockInstance) blockInstance.stop();
          }
        );
        break;
      default:
        if ($scope.taskMode === 'by_unit') {
          $scope.getBlockTasks('block-workflow', options, null, ['workflow_instance.unit.building', 'workflow_instance.unit.number'], false).then(
            function (data) {
              updateResultTask(data, defer, blockInstance);
            },
            function (error) {
              defer.reject(error);
              if (blockInstance) blockInstance.stop();  // Stop the correct blockUI instance
            }
          );
        } else {
          params = $scope.getParams($scope.dueDate, $scope.reset_page);
        promises.push(
            $scope.getBlockTasks('block', options, params).then(
            function (data) {
              $scope.tasks = data.results;
              $scope.datas['tasks'] = data.data;
            },
            function (error) {
              if (error.data && angular.isString(error.data.detail) && error.data.detail.startsWith('Invalid page')) {
                $scope.tasks = [];
                $scope.datas['tasks'] = {};
              }
            }
            )
          );
          if (!isNull(params['period'])) {
            delete params['due_date__gte'];
            delete params['due_date__lte'];
            delete params['due_date'];
            params['due_date__lt'] = params['period'] === 1 ? $scope.period_prev_date : $scope.rangeDates[0];
            promises.push(
              $scope.getBlockTasks('block', options, params).then(
                function (data) {
                  $scope.dueTasks = data.results;
                  $scope.datas['due_tasks'] = data.data;
                },
                function (error) {
                  if (error.data && angular.isString(error.data.detail) && error.data.detail.startsWith('Invalid page')) {
                    $scope.dueTasks = [];
                    $scope.datas['due_tasks'] = {};
                  }
                }
              )
            );
          }
          $q.all(promises).then(function () {
            defer.resolve($scope.updateData());
            $scope.stopAllBlocks();
          }).catch(function (error) {
            $scope.stopAllBlocks();
          });
        }
        break;
    }
      $timeout(function () {
        $scope.init = true;
        $scope.reset_page = false;
      }, 1000);
    return defer.promise;
  };

  $scope.groupByUnit = function () {
    $scope.taskGroups = [];
    $scope.tasks_no_unit = [];
    var tasks = angular.copy($scope.tasks);
    angular.forEach(tasks, function (value) {
      if (value.workflow_instance && value.workflow_instance.unit) {
        if ($scope.getIndexUnit(value.workflow_instance.unit.id) < 0) {
          var type = value.workflow_instance.unit.unit_type ? value.workflow_instance.unit.unit_type.name : '';
          $scope.taskGroups.push({
            id: value.workflow_instance.unit.id,
            number: value.workflow_instance.unit.number,
            building: value.workflow_instance.unit.building,
            type: type,
            tasks: [],
            next_tasks: []
          });
        }
        $scope.taskGroups[$scope.getIndexUnit(value.workflow_instance.unit.id)].tasks.push(value);
        angular.forEach(value.workflow_instance.pending_templates, function (task) {
          if (getIndexArray($scope.taskGroups[$scope.getIndexUnit(value.workflow_instance.unit.id)].next_tasks, task.id) < 0) {
            $scope.taskGroups[$scope.getIndexUnit(value.workflow_instance.unit.id)].next_tasks.push(task);
          }
        });
      } else {
        $scope.tasks_no_unit.push(value);
      }
    });
  };

  $scope.getIndexUnit = function (unit_id) {
    var index = -1;
    angular.forEach($scope.taskGroups, function (value, key) {
      if (value.id === unit_id) {
        index = key;
      }
    });
    return index;
  };

  $controller('TableFilterController', { $scope: $scope });

  $scope.initParams();

  $scope.getDatesPeriod($attrs.mode, $scope.dueDate);

  $scope.updateListTasks = function (task) {
    if ($attrs.mode === 'workspace') {
      angular.forEach($scope.tasks_left, function (value) {
        updateleftrightTask(value, task);
      });
      angular.forEach($scope.tasks_right, function (value) {
        updateleftrightTask(value, task);
      });
    } else {
      angular.forEach($scope.tasks, function (value) {
        updateTaskwithbroadcast(value, task);
      });
      angular.forEach($scope.dueTasks, function (value) {
        updateTaskwithbroadcast(value, task);

      });
    }
  };

  if (FilterService.initialized) {
    $scope.loadPage($scope.page);
  } else {
    $scope.$on('filter-service:initiated', function () {
      $scope.loadPage($scope.page);
    });
  }

  $scope.$on('filter-service:filter-changed', function ($event, key) {
    if (_.contains(['property'], key) && FilterService.initialized) {
      $scope.update = true;
      $scope.reset_page = true;
      $scope.loadPage(1);
    }
  });

  $scope.$on('filter-selection:updated', function () {
    if (FilterService.initialized) {
      $scope.update = true;
      $scope.reset_page = true;
    }
  });

  $scope.$on('task-status-date:updated', function (event, mode, dueDate) {
    if (['completed', 'cannot-do', 'review-pending', 'review-revision', 'review-rejected'].includes($attrs.mode)) {
      $scope.getDatesPeriod(mode, dueDate);
      $scope.updateTasks(mode, dueDate);
    }
  });

  $scope.$on('task-recurrence-dialog:success', function () {
    $scope.update = true;
    $scope.loadPage($scope.page);
  });

  $scope.$on('task-priority-dialog:success', function () {
    $scope.update = true;
    $scope.loadPage($scope.page);
  });

  $scope.$on('task-deactivate-dialog:success', function () {
    $scope.update = true;
    $scope.loadPage($scope.page);
  });

  $scope.$on('task-un-resolve-dialog:success', function () {
    $scope.update = true;
    $scope.loadPage($scope.page);
  });

  $scope.$on('task-assign-user:updated', function ($event, task) {
    $scope.updateListTasks(task);
  });

  $scope.$on('task-notes:updated', function ($event, task) {
    $scope.updateListTasks(task);
  });

  $scope.$on('template:updated', function ($event, task) {
    $timeout(function () {
      $scope.updateListTasks(task);
    }, 100);
  });

  $scope.$on('task-request-approval-dialog:success', function ($event, task) {
    if ($attrs.mode === 'review-pending') {
      $scope.update = true;
      $scope.loadPage($scope.page);
    } else {
      angular.forEach($scope.tasks, function (value) {
        updateleftrightTask(value, task);
      });
      angular.forEach($scope.dueTasks, function (value) {
        updateleftrightTask(value, task);
      });
    }
  });

  $scope.$on('task-resolve-dialog:success', function ($event, task) {
    if ($attrs.mode === 'completed' || $attrs.mode === 'workspace') {
      $scope.update = true;
      $scope.loadPage($scope.page);
    } else {
      angular.forEach($scope.tasks, function (value) {
        updateleftrightTask(value, task);
      });
      angular.forEach($scope.dueTasks, function (value) {
        updateleftrightTask(value, task);
      });
    }
  });

  $scope.$on('task-snooze-dialog:success', function ($event, task) {
    if ($attrs.mode === 'snoozed') {
      $scope.update = true;
      $scope.loadPage($scope.page);
    } else {
      $scope.updateListTasks(task);
    }
  });

  $scope.$on('task-cannot-do-dialog:success', function ($event, task) {
    if ($attrs.mode === 'cannot-do' || $attrs.mode === 'workspace') {
      $scope.update = true;
      $scope.loadPage($scope.page);
    } else {
      angular.forEach($scope.tasks, function (value) {
        updateleftrightTask(value, task);
      });
      angular.forEach($scope.dueTasks, function (value) {
        updateleftrightTask(value, task);
      });
    }
  });

  $scope.$on('task-workflow-status:updated', function ($event, task) {
    $scope.updateListTasks(task);
  });

  $scope.$on('task-dynamic-form-data:updated', function ($event, task) {
    $scope.updateListTasks(task);
  });

  $scope.$on('workflow-tasks:updated', function () {
    if ($attrs.mode === 'workflow') {
      $scope.update = true;
      $scope.loadPage($scope.page);
    }
  });

  $scope.$on('close-unit-dynamic-form', function () {
    $scope.loadPage($scope.page);
  });

  function updateResultTask(data, defer, blockInstance) {
    $scope.tasks = data.results;
    $scope.groupByUnit();
    defer.resolve(data.data);
    if (blockInstance) blockInstance.stop();  // Stop the correct blockUI instance
  }

  function updatetaskdocumentdetail(data, defer, blockInstance) {
    $scope.tasks = data.results;
    $scope.tasks_daily = data.tasks['daily'];
    $scope.tasks_weekly = data.tasks['weekly'];
    $scope.tasks_monthly = data.tasks['monthly'];
    $scope.tasks_documents = data.tasks['document'];
    $scope.tasks_workflows = data.tasks['workflow'];
    defer.resolve(data.data);
    if (blockInstance) blockInstance.stop(); 
  }

  function updateTaskwithoutdocumentdetail(data, defer, blockInstance) {
    $scope.tasks = data.results;
    $scope.tasks_daily = data.tasks['daily'];
    $scope.tasks_weekly = data.tasks['weekly'];
    $scope.tasks_monthly = data.tasks['monthly'];
    $scope.tasks_workflows = data.tasks['workflow'];
    defer.resolve(data.data);
    if (blockInstance) blockInstance.stop();
  }

  function updateleftrightTask(value, task) {
    if (value.id === task.id) {
      $scope.update = true;
      $scope.loadPage($scope.page);
    }
  }

  function updateTaskwithbroadcast(value, task) {
    if (value.id === task.id) {
      $scope.update = true;
      $rootScope.$broadcast('filter-selection:updated');
    }
  }

  $scope.$on('$destroy', function() {
    $scope.stopAllBlocks();
    // Clean up block instances
    [pendingBlock, cannotDoBlock, reviewPendingBlock, reviewRevisionBlock, reviewRejectedBlock, completedBlock].forEach(block => {
      if (block) {
        block.reset();
      }
    });
  });
};   

app.controller('TaskListPaginated', [
  '$scope',
  '$state',
  '$q',
  '$filter',
  '$attrs',
  'FilterService',
  'TaskService',
  'RecurrenceService',
  '$timeout',
  'ngDialog',
  'PropertyService',
  'TemplateService',
  '$controller',
  '$rootScope',
  'blockUI',
  TaskListPaginated
]);
